import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LocalDateTimeRange } from '../shared';
import { ChargeMetadata } from './ChargeMetadata';
export class PerMinuteFeeChargeMetadata extends ChargeMetadata {
    constructor(duration, timeRange) {
        super();
        this.duration = duration;
        this.timeRange = timeRange;
    }
}
__decorate([
    Type(() => LocalDateTimeRange),
    __metadata("design:type", LocalDateTimeRange)
], PerMinuteFeeChargeMetadata.prototype, "timeRange", void 0);
